import { useCallback } from 'react'
import { useSettings } from './useSettings'

export function useContractSupport() {
  const [contractSupportRef, setContractSupportRef] = useSettings('contractSupportRef', {
    remote: false,
  })

  const disableContractSupport = useCallback(() => {
    setContractSupportRef('')
  }, [setContractSupportRef])

  return {
    contractSupportRef,
    disableContractSupport,
    setContractSupportRef,
  }
}
